class IncompleteForms {
	constructor() {
		this.init();
	}

	init() {
        $(document).ready(function() {
            if($('.prevent-leave-incomplete').length){
                // Variable to track form completion status
                let formStarted = false;

                const requiredFormId = $('.prevent-leave-incomplete:first').attr('id').replace('gform_','');
                $(document).on('gform_post_render', function(event, formId) {
                    if(formId == requiredFormId){
                        // maybe a previous submit attempt with validation errors
                        if($('.gform_validation_errors').length){
                            formStarted = true;
                        }
                        $('#gform_' + formId).find('input, select, textarea').on('change input', function() {
                            formStarted = true;
                        });
                    }
                });
            
                // Set form as complete when submit is attempted
                $(document).on('click','#gform_' + requiredFormId + ' input[type=submit]', function() {
                    formStarted = false; // submit attempt - no need for popup
                });

                // Check for form completion status when user tries to leave the page
                window.onbeforeunload = function() {
                    if (formStarted) {
                        return true;
                    }
                };
            }
        });
	}
}

export default IncompleteForms;